import { FILE_UPLOAD_ALL_FILES_UPLOAD_START, FILE_UPLOAD_SINGLE_FILE_UPLOAD_COMPLETE, FILE_UPLOAD_SINGLE_FILE_UPLOAD_START, FILE_UPLOAD_SCALE_IMAGE_COMPLETE, FILE_UPLOAD_ADD_SINGLE_FILE, FILE_UPLOAD_SINGLE_FILE_UPLOAD_CANCEL, FILE_UPLOAD_RETRY_FILES_UPLOAD_START, FILE_UPLOAD_RC_ALL_FILES_UPLOAD_START, FILE_UPLOAD_RC_SINGLE_FILE_UPLOAD_COMPLETE, FILE_UPLOAD_RC_SINGLE_FILE_UPLOAD_START, FILE_UPLOAD_RC_SCALE_IMAGE_COMPLETE, FILE_UPLOAD_RC_ADD_SINGLE_FILE, FILE_UPLOAD_RC_SINGLE_FILE_UPLOAD_CANCEL, FILE_UPLOAD_RC_RETRY_FILES_UPLOAD_START } from '../actions';
import { uploadFilesReducer } from './uploadFilesReducer';
import { singleFileUploadCompleteReducer } from './singleFileUploadCompleteReducer';
import { singleFileUploadStartReducer } from './singleFileUploadStartReducer';
import { imageScaleCompleteReducer } from './imageScaleCompleteReducer';
import { addSingleFileReducer } from './addSingleFileReducer';
import { createFileInfoState } from '../services';
import { singleFileUploadCancelReducer } from './singleFileUploadCancelReducer';
import { retryFilesUploadReducer } from './retryFilesUploadReducer';
export const fileUploadRootReducer = (state = createFileInfoState(), action) => {
    switch (action.type) {
        case FILE_UPLOAD_ALL_FILES_UPLOAD_START:
        case FILE_UPLOAD_RC_ALL_FILES_UPLOAD_START:
            return uploadFilesReducer(action);
        case FILE_UPLOAD_SINGLE_FILE_UPLOAD_COMPLETE:
        case FILE_UPLOAD_RC_SINGLE_FILE_UPLOAD_COMPLETE:
            return singleFileUploadCompleteReducer(state, action);
        case FILE_UPLOAD_SINGLE_FILE_UPLOAD_START:
        case FILE_UPLOAD_RC_SINGLE_FILE_UPLOAD_START:
            return singleFileUploadStartReducer(state, action);
        case FILE_UPLOAD_SCALE_IMAGE_COMPLETE:
        case FILE_UPLOAD_RC_SCALE_IMAGE_COMPLETE:
            return imageScaleCompleteReducer(state, action);
        case FILE_UPLOAD_ADD_SINGLE_FILE:
        case FILE_UPLOAD_RC_ADD_SINGLE_FILE:
            return addSingleFileReducer(state, action);
        case FILE_UPLOAD_SINGLE_FILE_UPLOAD_CANCEL:
        case FILE_UPLOAD_RC_SINGLE_FILE_UPLOAD_CANCEL:
            return singleFileUploadCancelReducer(state, action);
        case FILE_UPLOAD_RETRY_FILES_UPLOAD_START:
        case FILE_UPLOAD_RC_RETRY_FILES_UPLOAD_START:
            return retryFilesUploadReducer(state, action);
        default:
            return state;
    }
};
//# sourceMappingURL=fileUploadRootReducer.js.map